import { getEnv } from "@trillion/ui/lib/env";
import { createApiClient } from "@trillion/ui/lib/api-client";

// Board API client (cookie auth). Keeps the existing `api<T>(path, options)` call shape,
// now backed by the shared client (adds 204/empty-body handling + consistent errors).
export const { request: api } = createApiClient(() => getEnv("BOARD_API_URL"));
